import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../utility';

const initialState = {
    isCardFlipped: false,
    userDetails: null,
    cardType: '',
    upiPin: '',
    bookingDetails: null,
    convFee: null,
    totalPrice: 0,
    paymentInfoError: false,
    bookingDetailsError: false,
    paymentInfoLoading: false,
    bookingDetailsLoading: false,
    paymentInfo: null,
    currencies: null,
    paymentOptions: null,
    rurl: null,
    rMap: null,
    amountDetails: null,
    selectedPaypalOption: null
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.TOGGLE_FLIP_CARD:
            return updateObject(state,{ isCardFlipped: !state.isCardFlipped })
        case actionTypes.SET_UPI_PIN:
            return updateObject(state, { upiPin: action.val })
        case actionTypes.SET_BOOKING_DETAILS_LOADING:
            return updateObject(state, { bookingDetailsLoading: true })
        case actionTypes.GET_BOOKING_DETAILS_FAILED:
            return updateObject(state, { bookingDetailsError: true, bookingDetailsLoading: false })
        case actionTypes.SET_PAYMENT_INFO_LOADING:
            return updateObject(state, { paymentInfoLoading: true })
        case actionTypes.SET_PAYMENT_INFO:
            return updateObject(state, { 
                paymentInfoLoading: false,
                bookingDetails: action.paymentInfo.bookingDetails,
                origin: action.paymentInfo.bookingDetails.origin,
                destination: action.paymentInfo.bookingDetails.destination,
                paymentOptions: action.paymentInfo.paymentOptionJSON,
                currencies: action.paymentInfo.currencyConversionJSON,
                totalPrice: parseInt(action.paymentInfo.bookingDetails.fareBreakup["Total Flight Price"], 10)
            })
        case actionTypes.SET_PAY_NOW:
            console.log(action);
            return {
                ...state,
                rurl: action.rurl,
                rMap: action.rMap
            }
        case actionTypes.GET_PAYMENT_INFO_FAILED:
            return updateObject(state, { paymentInfoError: true, paymentInfoLoading: false })
        case actionTypes.SET_CARD_NUMBER_VALIDATION:
            return updateObject(state, { cardNumberValid: false, cardNumberTooltip: true })
        case actionTypes.SET_CARD_NAME_VALIDATION:
            return updateObject(state, { cardNameValid: false, cardNameTooltip: true })
        case actionTypes.SET_CVV_VAIDATION:
            return updateObject(state, { cvvValid: false, cvvTooltip: true })
        case actionTypes.SET_AMOUNT_DETAILS:
            return updateObject(state, { amountDetails: action.val })
        case actionTypes.SET_PAYPAL_OPTION:
            const selectedOption = state.currencies.currencies.find(currency => currency.code === action.val);
            return updateObject(state, { selectedPaypalOption: selectedOption });
        default: 
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/payments.js